export enum AuthServiceErrors {
  UNKNOWN_ERROR = '[AuthServiceError] unknown error',
  INVALID_EMAIL = '[AuthServiceError] invalid email',
  WRONG_PASWORD = '[AuthServiceError] wrong password',
  USER_NOT_FOUND = '[AuthServiceError] user not found',
  INVALID_PASSWORD = '[AuthServiceError] invalid password',
  EMAIL_ALREADY_IN_USE = '[AuthServiceError] email already in use',
  POP_UP_CLOSED_BY_USER = '[AuthServiceError] popup closed by user'
}
